import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgCapacity = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M6.4 2.4a.8.8 0 1 0-1.6 0v.8H4c-.882 0-1.6.718-1.6 1.6v2.028q.196-.027.4-.028a2.799 2.799 0 0 1 2.353 4.32 3 3 0 0 1 1.642 2.48h2.412a3 3 0 0 1 1.643-2.48 2.799 2.799 0 0 1 2.752-4.292V4.8c0-.882-.717-1.6-1.6-1.6h-.8v-.8a.8.8 0 1 0-1.6 0v.8h-3.2v-.8zM2.8 11a1.4 1.4 0 0 0 0-2.8 1.4 1.4 0 0 0 0 2.8M2 12a2 2 0 0 0-2 2c0 .22.18.4.4.4h4.8c.22 0 .4-.18.4-.4a2 2 0 0 0-2-2zm12.6-2.4a1.4 1.4 0 0 0-2.8 0 1.4 1.4 0 0 0 2.8 0M10.4 14c0 .22.18.4.4.4h4.8c.22 0 .4-.18.4-.4a2 2 0 0 0-2-2h-1.6a2 2 0 0 0-2 2"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCapacity);
export default ForwardRef;
